<script>
	/*
		TCareRadioButtonGroup.svelte
	*/

	import TCareRadioButton from "./TCareRadioButton.svelte";

	export let source;
	export let prop;
	export let setValue;
	export let options;
	
</script>

<style>
</style>

<div class="tcui-control radio-button-group">
	{#each options as option}
		<TCareRadioButton {source} {prop} {setValue} value={option.value} label={option.label} />
	{/each}	
</div>
